import { useMemo } from 'react';
import get from 'hs-lodash/get';
const useUserPermissions = data => useMemo(() => get(data, ['crmObject', 'userPermissions'], {
  currentUserCanEdit: false,
  currentUserCanView: false
}), [data]);
export default useUserPermissions;